"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregate = void 0;
function aggregate(src, seedOrAggregator, aggregator, resultSelector) {
    let aggregate;
    let aggregatorFn;
    if (typeof seedOrAggregator === 'function') {
        aggregatorFn = seedOrAggregator;
    }
    else {
        if (!aggregator) {
            throw new Error('Invalid use of aggregate overloads.');
        }
        aggregatorFn = aggregator;
        aggregate = seedOrAggregator;
    }
    let i = 0;
    for (const item of src) {
        if (aggregate === undefined) {
            aggregate = item;
        }
        else {
            aggregate = aggregatorFn(aggregate, item, i);
        }
        i++;
    }
    if (aggregate === undefined) {
        throw new Error('Sequence contains no elements');
    }
    return resultSelector ? resultSelector(aggregate) : aggregate;
}
exports.aggregate = aggregate;
//# sourceMappingURL=aggregate.js.map